<template>
  <div class="light-header">
    <div class="logo"></div>
    <div class="navigation">
      <div class="navigation-item app" v-if="isCompanyAccount">
        <DownloadAppPopover/>
        <i class="iconfont icona-bianzu59 extension-icon" @click="handleExtensionIconClick"></i>
      </div>
      <div class="navigation-item user">
        <HeaderUserMenu light-theme></HeaderUserMenu>
      </div>
      <div class="navigation-item language">
        <span class="language-name" @click="handleLanguageBtnClick">{{ anotherLanguageName }}</span>
      </div>
      <div class="navigation-item hotline">
        <i class="iconfont iconTelephone hotline-icon"></i>
        <div class="dropdown-container">
          <div class="hotline-list">
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.cnUser') }}</span>
              <span class="line-content phone">400-990-3308</span>
            </div>
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.allUser') }}</span>
              <span class="line-content email link">service@ajinga.com</span>
            </div>
          </div>
          <div class="dropdown-padding"></div>
          <div class="dropdown-arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderUserMenu from '@/components/layout/header/headerUserMenu.vue'
import DownloadAppPopover from '@/components/layout/header/downloadAppPopover.vue'
import { isEn, switchLanguageWithZhAndEn } from '@/i18n'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    HeaderUserMenu,
    DownloadAppPopover
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('account', [
      'isCandidateAccount',
      'isCompanyAccount',
      'isHeadhunterAccount',
      'hasEmployeeAccountInfo'
    ]),
    anotherLanguageName () {
      return isEn() ? '中文' : 'English'
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    handleLanguageBtnClick () {
      switchLanguageWithZhAndEn()
      this.changeLanguage(isEn() ? 'en' : 'zh-cn')
    },
    handleExtensionIconClick () {
      this.$router.push('/v-admin/widget-installation')
    }
  }
}
</script>

<style lang="scss" scoped>
.light-header {
  display: flex;
  width: 100%;
  height: 60px;
  padding: 0 20px 0 55px;
  background: #ffffff;

  .logo {
    width: 165px;
    margin-left: 0;
    margin-right: auto;
    background-image: url(~@/assets/image/ajinga_logo_black.png);
    background-size: 165px;
    background-repeat: no-repeat;
    background-position: 0;
  }

  .navigation {
    display: flex;
    margin-left: auto;
    margin-right: 0;
    align-items: center;

    .navigation-item {
      height: 24px;
      line-height: 24px;
      padding: 0 30px;

      + .navigation-item {
        border-left: 2px solid #e4e4ee;
      }

      &.app {
        .app-icon {
          display: inline-block;
          margin-top: -3px;
          line-height: 1;
          font-size: 30px;
          vertical-align: middle;
          cursor: pointer;
          color: #939393;
        }

        .extension-icon {
          display: inline-block;
          margin-top: -3px;
          margin-left: 30px;
          line-height: 1;
          font-size: 30px;
          vertical-align: middle;
          cursor: pointer;
          color: #939393;
        }
      }

      &.user {
        .user-menu {
          height: 35px;
          line-height: 35px;
        }
      }

      &.language {
        .language-name {
          cursor: pointer;
          line-height: 20px;
        }
      }

      &.hotline {
        position: relative;

        .hotline-icon {
          font-size: 24px;
          cursor: pointer;
          color: #939393;

          &:hover {
            ~ .dropdown-container {
              display: block;
            }
          }
        }

        .hotline-list {
          .detail-line {
            height: 22px;
            line-height: 22px;
            word-break: keep-all;
            white-space: nowrap;

            .line-label {
              display: inline-block;
              width: 85px;
              color: #333;
            }

            .line-content {
              margin-left: 10px;
              font-size: 14px;

              &.phone {
                color: #ff6633;
              }
              &.email{
                text-decoration: underline;
              }
            }
          }
        }

        .dropdown-container {
          display: none;
          margin-top: 20px;
          padding: 10px 15px;
          border: 1px solid #aaa;
          border-radius: 10px;
          background: #fff;
          cursor: pointer;
          position: absolute;
          top: 100%;
          right: 5px;
          z-index: 10;

          &:hover {
            display: block;
          }

          .dropdown-arrow {
            width: 22px;
            height: 15px;
            background: url($baseDomain + 'static/image/list_assets.png?t=5') no-repeat -20px -142px;
            position: absolute;
            top: -13px;
            right: 18px;
          }

          .dropdown-padding {
            width: 35px;
            height: 30px;
            position: absolute;
            top: -30px;
            right: 14px;
          }
        }
      }
    }
  }
}
</style>
